import React, {Component} from 'react';
import PrismaZoom from 'react-prismazoom';
import {Icon} from 'semantic-ui-react';
import {canDownload} from './utils';

class ZoomImage extends Component {
  render() {
    const {image} = this.props;
    let imgView;
    if (canDownload(image)) {
      imgView = <img width={150} alt='image_attachment' src={image} />;
    } else {
      imgView = <Icon name='file image' size='massive'/>;
    }
    return (
      <PrismaZoom maxZoom={3} style={{'zIndex': 1}}>
        {imgView}
      </PrismaZoom>
    );
  }
}

export default ZoomImage;
